import { poolsReducer } from './reducer';
import { initialPoolsState } from './state';

const POOLS_MODULE_NAME = 'pools';

export { POOLS_MODULE_NAME, initialPoolsState, poolsReducer };
